/* Original product-form component, connected to the Kutta cart. */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.hideErrors = this.dataset.hideErrors === 'true';
      if (!this.form || !this.submitButton || !this.variantIdInput) return;
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (document.querySelector('#KuttaCart')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    async onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitting || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (!this.form.reportValidity()) return;
      this.submitting = true;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');
      const cart = window.KuttaCart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(this.form);
      if (cart) {
        formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        formData.set('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      try {
        const url = cart?.getAddUrl ? cart.getAddUrl(this.form) : this.form.action;
        const response = await fetch(url, {
          method:'POST', body:formData, credentials:'same-origin',
          headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
        });
        let result;
        try { result = await response.json(); } catch { throw new Error(window.cartStrings?.error || 'Unable to update the cart.'); }
        if (!response.ok || Number(result.status) >= 400) {
          const message = typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : window.cartStrings?.error;
          publish(PUB_SUB_EVENTS.cartError, {source:'product-form',productVariantId:formData.get('id'),errors:result.errors || message,message});
          throw new Error(message || 'Unable to update the cart.');
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form',productVariantId:formData.get('id'),cartData:result});
        if (this.variantIdInput.dataset.skipCart === 'true') {
          const root = window.Shopify?.routes?.root || window.Kutta?.root || '/';
          window.location.assign(root.replace(/\/*$/, '/') + 'checkout');
        } else if (cart) {
          const modal = this.closest('quick-add-modal');
          if (modal) modal.hide(true);
          await cart.renderContents(result);
        } else {
          window.location.assign(window.routes?.cart_url || '/cart');
        }
      } catch (error) {
        this.handleErrorMessage(error.message || window.cartStrings?.error);
      } finally {
        this.submitting = false;
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.removeAttribute('aria-busy');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
    handleErrorMessage(message = false) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      wrapper.toggleAttribute('hidden', !message);
      const text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message || '';
    }
    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      this.submitButton.disabled = disable;
      if (this.submitButtonText && (text || !disable)) this.submitButtonText.textContent = disable ? text : window.variantStrings.addToCart;
    }
    get variantIdInput() { return this.form?.querySelector('[name="id"]'); }
  });
}
